/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'page-next-outline': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M22 3H5a2 2 0 00-2 2v4h2V5h17v14H5v-4H3v4a2 2 0 002 2h17a2 2 0 002-2V5a2 2 0 00-2-2M7 15v-2H0v-2h7V9l4 3-4 3m13-2h-7v-2h7v2m0-4h-7V7h7v2m-3 8h-4v-2h4v2z"/>'
  }
})
